const blockContextMenu = e => {
  e.preventDefault();
  return false;
};

export default blockContextMenu;
